export function getFilter(state) {
    return state.filter;
}
